import * as React from 'react';

export default class inboxIcons extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
       <g id="left-nav-primary-icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-637.000000, -133.000000)">
			<g id="Group-8" transform="translate(618.000000, 133.000000)">
				<g id="Group-8-Copy-2" transform="translate(19.000000, 0.000000)">
					<g id="Group-2">
						<g id="Group-7" transform="translate(2.000000, 2.000000)">
							<path d="M4.5,4.5 L2,4.5 C1.72385763,4.5 1.5,4.72385763 1.5,5 L1.5,15 C1.5,15.2761424 1.72385763,15.5 2,15.5 L4.5,15.5 L4.5,17 L2,17 C0.8954305,17 0,16.1045695 0,15 L0,5 C0,3.8954305 0.8954305,3 2,3 L4.5,3 L4.5,4.5 Z" id="Rectangle-Copy-2" fill="#333" fillRule="nonzero"></path>
							<path d="M15.5,15.5 L18,15.5 C18.2761424,15.5 18.5,15.2761424 18.5,15 L18.5,5 C18.5,4.72385763 18.2761424,4.5 18,4.5 L15.5,4.5 L15.5,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,15 C20,16.1045695 19.1045695,17 18,17 L15.5,17 L15.5,15.5 Z" id="Rectangle-Copy" fill="#333" fillRule="nonzero"></path>
							<rect id="Rectangle" stroke="#333" strokeWidth="1.5" x="4.75" y="0.75" width="10.5" height="18.5" rx="2"></rect>
						</g>
					</g>
				</g>
			</g>
		</g>
      </svg>
    )
  }
}
